// extracted by mini-css-extract-plugin
export var border = "style-module--border--x+ZNf";
export var circle = "style-module--circle--brgFk";
export var divider = "style-module--divider--JY0iT";
export var dots = "style-module--dots--2aaI6";
export var dotsWrapper = "style-module--dotsWrapper--FqjAb";
export var gadgetPosition = "style-module--gadgetPosition--swSr9";
export var gadgetPosition2 = "style-module--gadgetPosition2--f6Jvj";
export var header = "style-module--header--aaxZW";
export var icon = "style-module--icon--Icvo+";
export var imageWrapper = "style-module--imageWrapper--bhorK";
export var line = "style-module--line--lWu97";
export var linkedin = "style-module--linkedin--izE21";
export var mentor = "style-module--mentor--aHx-W";
export var name = "style-module--name--jLLkA";
export var projectName = "style-module--projectName--pXa3X";
export var projectOptions = "style-module--projectOptions--oAh8P";
export var root = "style-module--root--dBLk-";
export var root1 = "style-module--root1--Gk8vZ";
export var title = "style-module--title--MwHJE";
export var title1 = "style-module--title1--QihGV";
export var value = "style-module--value--ud71H";